import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( ) => ({
  divider: {
    height: 32,
    width: 2,
    margin: "0 4px",
  }
}));

export default useStyle;